import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelCheckinPassengerAdditionResultRequest,
  failCheckinPassengerAdditionResult,
  setCheckinPassengerAdditionResult,
  setCheckinPassengerAdditionResultFromApi,
  updateCheckinPassengerAdditionResult,
  updateCheckinPassengerAdditionResultFromApi,
} from './checkin-passenger-addition-result.actions';

/**
 * Service to handle async CheckinPassengerAdditionResult actions
 */
@Injectable()
export class CheckinPassengerAdditionResultEffect {
  /**
   * Set the state with the reply content, dispatch failCheckinPassengerAdditionResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCheckinPassengerAdditionResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setCheckinPassengerAdditionResult({ ...reply, requestId: action.requestId }),
        (error, action) => of(failCheckinPassengerAdditionResult({ error, requestId: action.requestId })),
        cancelCheckinPassengerAdditionResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failCheckinPassengerAdditionResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCheckinPassengerAdditionResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateCheckinPassengerAdditionResult({ ...reply, requestId: payload.requestId })),
          catchError((err) => of(failCheckinPassengerAdditionResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
